var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "organize",
    attrs: {
      id: "upload-document-modal",
      "modal-dialog-size": "xs",
      "modal-dialog-scrollable": false,
    },
    on: { hide: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h5",
              { staticClass: "modal-title", attrs: { id: "modal-title" } },
              [
                _vm._v("\n      " + _vm._s(_vm.title) + ":\n      "),
                _c("i", [
                  _vm._v("\n        " + _vm._s(_vm.documentsInfo) + "\n      "),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.isSelectFilesCurrentStep
              ? _c("select-files-step", {
                  attrs: {
                    files: _vm.files,
                    "selected-files": _vm.selectedFiles,
                  },
                  on: {
                    selectFile: _vm.handleSelectFile,
                    selectAllFiles: _vm.handleSelectAllFiles,
                  },
                })
              : _vm.isSelectApplicationCurrentStep
              ? _c("select-application-step", {
                  attrs: {
                    "application-id": _vm.applicationId,
                    applications: _vm.applications,
                    "client-username": _vm.clientUsername,
                  },
                  on: {
                    change: function (value) {
                      return _vm.handleChange(value, "applicationId")
                    },
                  },
                })
              : _c("select-classification-step", {
                  attrs: {
                    "application-id": _vm.applicationId,
                    "client-username": _vm.clientUsername,
                    "allow-create": _vm.allowCreate,
                    "selected-type": _vm.selectedType,
                    "selected-classification": _vm.selectedClassification,
                    "current-classification": _vm.currentClassification,
                  },
                  on: {
                    "update:selectedType": function ($event) {
                      _vm.selectedType = $event
                    },
                    "update:selected-type": function ($event) {
                      _vm.selectedType = $event
                    },
                    change: _vm.handleChange,
                  },
                }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", {
              ref: "submitDocument",
              attrs: {
                text: _vm.buttonText,
                disabled: !_vm.canSubmit,
                loading: _vm.uploading,
                "loading-succeeded": _vm.uploadingSucceeded,
              },
              on: { finish: _vm.closeModal, click: _vm.handleSubmit },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }